module.exports = __webpack_public_path__ + "img/image_input_icon.ad22f1e5.svg";